export default {
    name: "GetLocation",
    title: "Get Location",
    icon: "mdi-database-search",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            target: null,
            childAction1: [],
            childAction2: []
        };
    },
};